// extracted by mini-css-extract-plugin
export default {"wrapper":"Price_wrapper__rLHOw"};